import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { COLORS } from '@traton/common-ui';
import { Announcement } from '@internal/backstage-plugin-announcement-common';

interface AnnouncementContentProps {
  title?: string;
  message: string;
  links?: Announcement['links'];
}

export const AnnouncementContent = ({
  title,
  message,
  links,
}: AnnouncementContentProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        pt: '2px',
      }}
    >
      {/* Title (bold) + message (regular) grouped with tight gap */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
        }}
      >
        {title && (
          <Typography
            variant="body2"
            sx={{
              fontWeight: theme.typography.fontWeightBold,
              color: COLORS.light.TRATON_White,
              wordBreak: 'break-word',
            }}
          >
            {title}
          </Typography>
        )}
        <Typography
          variant="body2"
          sx={{
            color: COLORS.light.TRATON_White,
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
          }}
        >
          {message}
        </Typography>
      </Box>

      {links && links.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          {links.map(link => (
            <Typography
              key={link.id}
              component="a"
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              sx={{
                color: COLORS.light.TRATON_White,
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              {link.text}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  );
};
